import React, { useState } from 'react';
import './Bank.css';

const Banking = () => {
  const [activeTab, setActiveTab] = useState('accounts');
  const [showTransferForm, setShowTransferForm] = useState(false);
  const [transferAmount, setTransferAmount] = useState('');
  const [transferFrom, setTransferFrom] = useState('');
  const [transferTo, setTransferTo] = useState('');

  const accounts = [
    { id: 1, name: 'Checking', number: '••1234', balance: 5420.50, type: 'checking' },
    { id: 2, name: 'Savings', number: '••5678', balance: 12750.25, type: 'savings' },
    { id: 3, name: 'Investment', number: '••9012', balance: 38520.75, type: 'investment' }
  ];

  const transactions = [
    { id: 1, date: '2023-10-15', description: 'Starbucks Coffee', amount: -5.75, category: 'Food & Drink' },
    { id: 2, date: '2023-10-14', description: 'Amazon Purchase', amount: -32.99, category: 'Shopping' },
    { id: 3, date: '2023-10-13', description: 'Salary Deposit', amount: 2500.00, category: 'Income' },
    { id: 4, date: '2023-10-12', description: 'Electric Bill', amount: -87.34, category: 'Utilities' },
    { id: 5, date: '2023-10-10', description: 'Transfer from John', amount: 150.00, category: 'Transfer' }
  ];

  const handleTransfer = (e) => {
    e.preventDefault();
    alert(`Transfer of $${transferAmount} from ${transferFrom} to ${transferTo} completed!`);
    setShowTransferForm(false);
    setTransferAmount('');
    setTransferFrom('');
    setTransferTo('');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const formatDate = (dateString) => {
    const options = { month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="fintech-container" style={{ padding: '8rem 0 4rem' }}>
      <div className="banking-header">
        <h1>Banking</h1>
        <p>Manage your accounts and transactions</p>
      </div>

      <div className="banking-tabs">
        <button 
          className={activeTab === 'accounts' ? 'active' : ''}
          onClick={() => setActiveTab('accounts')}
        >
          Accounts
        </button>
        <button 
          className={activeTab === 'transactions' ? 'active' : ''}
          onClick={() => setActiveTab('transactions')}
        >
          Transactions
        </button>
        <button 
          className={activeTab === 'transfer' ? 'active' : ''}
          onClick={() => setActiveTab('transfer')}
        >
          Transfer
        </button>
      </div>

      <div className="banking-content">
        {activeTab === 'accounts' && (
          <div className="accounts-section">
            <h2 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>Your Accounts</h2>
            <div className="bento-grid">
              {accounts.map(account => (
                <div key={account.id} className="bento-box col-span-1 account-card">
                  <div className="account-header">
                    <h3>{account.name}</h3>
                    <span className="account-number">{account.number}</span>
                  </div>
                  <div className="account-balance">
                    {formatCurrency(account.balance)}
                  </div>
                  <div className="account-actions">
                    <button className="action-btn">View Details</button>
                    <button 
                      className="action-btn primary"
                      onClick={() => {
                        setActiveTab('transfer');
                        setTransferFrom(`${account.name} •${account.number}`);
                      }}
                    >
                      Transfer
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'transactions' && (
          <div className="bento-box col-span-4 transactions-section">
            <h2 style={{ marginBottom: '1.5rem' }}>Recent Transactions</h2>
            <div className="transactions-filters">
              <select>
                <option>All Accounts</option>
                {accounts.map(account => (
                  <option key={account.id}>{account.name}</option>
                ))}
              </select>
              <select>
                <option>All Categories</option>
                <option>Food & Drink</option>
                <option>Shopping</option>
                <option>Income</option>
                <option>Utilities</option>
                <option>Transfer</option>
              </select>
            </div>
            <div className="transactions-list">
              {transactions.map(transaction => (
                <div key={transaction.id} className="transaction-item">
                  <div className="transaction-date">
                    {formatDate(transaction.date)}
                  </div>
                  <div className="transaction-details">
                    <div className="transaction-description">
                      {transaction.description}
                    </div>
                    <div className="transaction-category">
                      {transaction.category}
                    </div>
                  </div>
                  <div className={`transaction-amount ${transaction.amount >= 0 ? 'positive' : 'negative'}`}>
                    {formatCurrency(transaction.amount)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'transfer' && (
          <div className="bento-box col-span-4 transfer-section" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Transfer Money</h2>
            {!showTransferForm ? (
              <div className="transfer-init">
                <p>Move money between your accounts or to external recipients</p>
                <button 
                  className="transfer-btn"
                  onClick={() => setShowTransferForm(true)}
                >
                  Start Transfer
                </button>
              </div>
            ) : (
              <form className="transfer-form" onSubmit={handleTransfer}>
                <div className="form-group">
                  <label>From Account</label>
                  <select 
                    value={transferFrom} 
                    onChange={(e) => setTransferFrom(e.target.value)}
                    required
                  >
                    <option value="">Select account</option>
                    {accounts.map(account => (
                      <option key={account.id} value={`${account.name} •${account.number}`}>
                        {account.name} •{account.number} ({formatCurrency(account.balance)})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>To Account</label>
                  <select 
                    value={transferTo} 
                    onChange={(e) => setTransferTo(e.target.value)}
                    required
                  >
                    <option value="">Select account</option>
                    {accounts.map(account => (
                      <option key={account.id} value={`${account.name} •${account.number}`}>
                        {account.name} •{account.number}
                      </option>
                    ))}
                    <option value="external">External Account</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Amount</label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={transferAmount}
                    onChange={(e) => setTransferAmount(e.target.value)}
                    required
                    min="0.01"
                    step="0.01"
                  />
                </div>

                <div className="form-actions">
                  <button 
                    type="button" 
                    className="cancel-btn"
                    onClick={() => setShowTransferForm(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="submit-btn">
                    Confirm Transfer
                  </button>
                </div>
              </form>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Banking;